module.exports = __webpack_public_path__ + "media/images/vp/samples/07-e4207406b58e5d191a2623011241ae84.jpg";